import EsusView from 'components/esus/EsusView'

export default function FichaCadastroDomiciliarView() {
  return <EsusView url='/pec/user/cds/cadastroDomiciliar' />
}
